export const getURLHelper = (link, prefix = '')  => {
  try {
    const url = new URL(link);
    if (url.protocol === "http:" || url.protocol === "https:") {
      return link;
    }
  } catch (error) {}
  if (link && link !== "" && link[0] === "/") {
    return prefix + link;
  } else if (prefix !== "") {
    return (prefix + "/" + (link ? link : ""))
  } else {
    return link ?? "";
  }
}

export const getProductCatUrl = (link) => {
  return getURLHelper(link, '/products');
}
